import { GetHighlightsParams } from './highlights.types'

export const getHighlights = ({
  i18n,
  pagesCompleted,
  classCommentsCount,
  communityPostsCount
}: GetHighlightsParams) => {
  return [
    {
      icon: '🎯',
      amount: pagesCompleted,
      label:
        pagesCompleted === 1
          ? i18n.t('profile.highlights.class.singular')
          : i18n.t('profile.highlights.class.plural')
    },
    {
      icon: '💬',
      amount: classCommentsCount,
      label:
        classCommentsCount === 1
          ? i18n.t('profile.highlights.comment.singular')
          : i18n.t('profile.highlights.comment.plural')
    },
    {
      icon: '✏️',
      amount: communityPostsCount,
      label:
        communityPostsCount === 1
          ? i18n.t('profile.highlights.post.singular')
          : i18n.t('profile.highlights.post.plural')
    }
  ].filter((highlight) => typeof highlight.amount === 'number')
}
